<template>
  <div class="theme-toggler" data-vv-value-path="model" :data-vv-as="label">
      <label class="theme-toggler__switch">
        <input
          class="theme-toggler__input"
          :class="model == '1' ? 'active' : ''"
          :name="name"
          :value="model"
          :disabled="disabled"
          @click="stateChange(), $emit('click', model), $emit('input', model), $emit('change', model)"
        >
        <span class="theme-toggler__slider"></span>
      </label>
    <label>{{ label }}</label>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        model: this.value,
      }
    },
    props: {
      label: {
        default: '',
        type: String
      },
      value: {
        default: '',
        type: String
      },
      name: {
        default: '',
        type: String
      },
      disabled: {
        default: false,
        type: Boolean,
      },
    },
    methods: {
      stateChange() {
        this.model == '1' ? this.model = '0' : this.model = '1';
      },
    },
  }
</script>